import { useQuery } from '@tanstack/react-query'

import type { CalculateChildrenSavingsRequest } from 'aem-libs-api/src/services/rfa-depositcalc/v1/types'
import { apiRequest } from 'aem-libs-react-ts/src/services/apiRequest'

import { APP_NAME } from '../inlet'
import { rfaDepositApi } from '../services/api'

const calculateChildrenSavings = apiRequest(rfaDepositApi.calculateChildrenSavings, {
  skipFirstTracking: true,
  trackResponse: true,
  trackMapper: (resp) => ({ totalAmount: resp.untilLegalAgeCalculation.totalSavingsAmount })
})

export const useCalculateChildrenSavingsQuery = (request: CalculateChildrenSavingsRequest) => {
  return useQuery({
    queryKey: [APP_NAME, request.age.toString(), request.monthlyAmount.toString(), request.initialAmount.toString()],
    queryFn: () => calculateChildrenSavings(request),
    select: (response) => response.data,
    placeholderData: (res) => res
  })
}
